/////////////////////////////////////////////////////////////
//  В vue.config.js добавить  runtimeCompiler: true!!!!!!///
///////////////////////////////////////////////////////////
import { CellEditorSelectorResult } from 'ag-grid-community'
import { Component, Vue } from 'vue-property-decorator'

const KEY_LEFT = 37
const KEY_UP = 38
const KEY_RIGHT = 39
const KEY_DOWN = 40
const KEY_PAGE_UP = 33
const KEY_PAGE_DOWN = 34
const KEY_PAGE_HOME = 36
const KEY_PAGE_END = 35

@Component({
  name: 'c-window-cell-editor',

  template: `
    <div class="window-editor">
      <textarea id="table-window-editor"
        cols="30"
        rows="6"
        v-model="value"
        placeholder="Введите текст"/>
      <div class="buttons">
        <button class="save"
                @click="save">
          Сохранить
        </button>

        <button class="cancel"
                @click="cancel">
          Отменить
        </button>
      </div>
    </div>
  `,
})
export default class WindowCellEditor extends Vue<CellEditorSelectorResult> {
  value = null
  dateFormat = null
  maxLength = null
  isCanceled = false

  cancel (): void {
    this.isCanceled = true;

    this.params.stopEditing()
  }

  save (): void {
    this.params.stopEditing()
  }

  // Возвращает значение в ячейку таблицы
  getValue () {
    return this.value
  }

  // Инпут будет отображаться  поверх таблицы
  isPopup () {
    return 'over'
  }

  onKeyDown (event: KeyboardEvent): void {
    const keyCode = event.keyCode
    const isNavigationKey =
      keyCode === KEY_LEFT ||
      keyCode === KEY_RIGHT ||
      keyCode === KEY_UP ||
      keyCode === KEY_DOWN ||
      keyCode === KEY_PAGE_DOWN ||
      keyCode === KEY_PAGE_UP ||
      keyCode === KEY_PAGE_HOME ||
      keyCode === KEY_PAGE_END

    if (isNavigationKey) {
      event.stopPropagation()
    }
  }

  isCancelAfterEnd (): boolean {
    return this.isCanceled
  }

  mounted (): void {
    this.value = (this as any).params.value
    this.maxLength = (this as any).params.maxLength

    Vue.nextTick(() => {
      (document.getElementById('table-window-editor') as HTMLInputElement).focus()
    })
  }
}
